/* eslint-disable max-len */
export const footerContent = {
  gri: 'heloc_footer',
  owning: 'owning_footer'
};
